module.exports = __webpack_public_path__ + "static/media/louisLiSmiling.5d5be51c.jpeg";